import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthStore } from './auth.store';

/** Redirige vers /login tant que l'hydratation Sanctum n'a pas donné de staff. */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthStore);
  const router = inject(Router);

  return auth.user() !== null ? true : router.parseUrl('/login');
};
